import React, { Component } from "react";
import { Table, Tag, Button } from "antd";
import { ShipmentTableHelpers } from "./ShipmentTableHelpers";

class ManifestsTable extends Component {

    render() {
        const { manifests } = this.props;

        const columns = [
            {
                title: 'Manifest ID',
                dataIndex: 'manifestId',
                key: 'manifestId',
                width: '30%',
                render: (text) => {
                    return (
                        <span style={{
                            fontWeight: '700',
                            fontSize: '14px',
                            fontFamily: 'monospace'
                        }}>
                            {text}
                        </span>
                    );
                }
            },
            {
                title: 'Created Date',
                dataIndex: 'lastModified',
                key: 'lastModified',
                width: '18%',
                render: (text) => {
                    return text ? new Date(text).toLocaleDateString('en-AU', {
                        year: 'numeric',
                        month: '2-digit',
                        day: '2-digit',
                        hour: '2-digit',
                        minute: '2-digit'
                    }) : 'N/A';
                },
                sorter: (a, b) => new Date(a.lastModified) - new Date(b.lastModified),
                defaultSortOrder: 'descend'
            },
            {
                title: 'Brand',
                dataIndex: 'brand',
                key: 'brand',
                width: '12%',
                render: (text) => {
                    let style = {};
                    if (text === 'US') {
                        style = {
                            backgroundColor: '#000',
                            color: '#fff',
                            border: 'none'
                        };
                    } else if (text === 'PS') {
                        style = {
                            backgroundColor: '#F2EFE6',
                            color: '#000',
                            border: 'none'
                        };
                    }

                    return (
                        <Tag
                            style={style}
                            color={text === 'US' || text === 'PS' ? undefined : 'default'}
                        >
                            {text}
                        </Tag>
                    );
                }
            },
            {
                title: 'Type',
                dataIndex: 'type',
                key: 'type',
                width: '12%',
                render: (text, record) => {
                    let style = {};

                    if (text === 'EXPRESS') {
                        style = {
                            backgroundColor: '#D71635',
                            color: '#fff',
                            border: 'none'
                        };
                    } else if (text === 'STANDARD') {
                        style = {
                            backgroundColor: 'rgb(215, 141, 22)',
                            color: '#fff',
                            border: 'none'
                        };
                    }

                    return (
                        <Tag
                            style={style}
                            color={Object.keys(style).length === 0 ? 'green' : undefined}
                        >
                            {text}
                        </Tag>
                    );
                }
            },
            {
                title: 'Download',
                dataIndex: 'manifestUrl',
                key: 'download',
                width: '16%',
                render: (manifestUrl, record) => {
                    return (
                        <Button
                            type="default"
                            onClick={(e) => {
                                e.stopPropagation();
                                if (manifestUrl) {
                                    window.open(manifestUrl, '_blank');
                                }
                            }}
                            disabled={!manifestUrl}
                            title={`View ${record.manifestId}`}
                        >
                            View
                        </Button>
                    );
                }
            }
        ];

        return (
            <Table
                columns={columns}
                dataSource={manifests}
                rowKey="manifestId"
                locale={{ emptyText: this.props.emptyMessage }}
                pagination={{
                    pageSize: 50,
                    showQuickJumper: true,
                    showSizeChanger: false,
                    showTotal: (total, range) => `${range[0]}-${range[1]} of ${total} manifests`
                }}
                scroll={{ x: 1000 }}
                size="middle"
            />
        );
    }
}

export default ManifestsTable;